export const DEVELOPMENT_DUMMY_TOKEN = 'DUMMY_TOKEN_FOR_LOCALHOST_DEVELOPMENT';
export const TEST_SITE_KEY = '1x00000000000000000000AA';
export const PRODUCTION_SITE_KEY = '0x4AAAAAABkQjnR7CCOnvo5L';

export const isDevelopmentEnvironment = () => {
  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' || 
                     hostname === '127.0.0.1' || 
                     hostname === '0.0.0.0' ||
                     hostname.includes('localhost');
  
  const isDevelopmentMode = process.env.NODE_ENV === 'development';
  const hasDevPort = window.location.port === '3000' || window.location.port === '3001';
  
  return isLocalhost || isDevelopmentMode || hasDevPort;
};

export const isTestSiteKey = (siteKey) => {
  return siteKey === TEST_SITE_KEY || siteKey?.startsWith('1x0000');
};

export const generateDummyToken = () => {
  const timestamp = Date.now();
  return `DUMMY_TOKEN_${timestamp}_LOCALHOST_DEV`;
};

export const handleCaptchaToken = (actualToken, siteKey) => {
  const isDev = isDevelopmentEnvironment();
  const isTestKey = isTestSiteKey(siteKey);
  
  if (isDev && isTestKey) {
    if (!actualToken || actualToken.includes('DUMMY') || actualToken.startsWith('XXXX')) {
      const dummyToken = generateDummyToken();
      return dummyToken;
    }
  }
  
  return actualToken;
};

export const getCaptchaErrorMessage = (error, siteKey) => {
  const isDev = isDevelopmentEnvironment();
  const isTestKey = isTestSiteKey(siteKey);
  
  if (isDev && !isTestKey) {
    return 'CAPTCHA configuration error. Please try again.';
  }
  
  if (!isDev && isTestKey) {
    return 'CAPTCHA configuration error. Please try again.';
  }
  
  if (error?.includes('400020') || error?.includes('invalid site key')) {
    return 'CAPTCHA configuration error. Please try again or contact support.';
  }
  
  return 'CAPTCHA verification failed. Please try again.';
}; 